import React from 'react'
import styled from 'styled-components'
import { css } from '@styled-system/css'
import ContentModal from 'ui/acro/blocks/ContentModal'
import { P, H2 } from 'ui/bend'
import { useWindowResize } from 'hooks'

const FeedFMDisclimerModalWrapper = styled.div`
  padding: 0.625rem 6.25rem;
  @media (max-width: 768px) {
    padding: 16px 12px;
  }
`
const Disclaimer = styled(P)(() =>
  css({
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0.352px',
    marginTop: '32px'
  })
)

const Title = styled(H2)(() =>
  css({
    fontSize: '32px',
    lineHeight: '40px',
    textAlign: 'center',
    color: '#000',
    '@media (max-width: 768px)': {
      fontSize: '20px'
    }
  })
)

export const FeedFMDisclimer = ({ modal }) => {
  const { width } = useWindowResize()

  return (
    <ContentModal
      width={width > 1200 ? '840px' : width > 768 ? '70%' : '92%'}
      position='relative'
      margin='0 auto'
      left='auto'
      top='102px'
      borderRadius='0px'
      useModal={modal}
    >
      <FeedFMDisclimerModalWrapper>
        <Title>feed.fm disclaimer</Title>
        <Disclaimer>
          There is no affiliation, connection, association or endorsement of the
          products, goods or services displayed on this page by the copyright
          owners, featured recording artists and authors of the sound recordings
          (and the musical works embodied therein) transmitted through the
          Feed.fm player.
        </Disclaimer>
      </FeedFMDisclimerModalWrapper>
    </ContentModal>
  )
}
